import useCompanyAttributesData from "@/company/data/useCompanyAttributesData";
import { useFeatureTargetingContextAttributeKeys } from "@/feature/data/useFeatureTargetingContextAttributesData";
import { withObservedAttributeType } from "@reflag/shared/attributeFilter";

import { EntityType } from "./useAttributeValues";

export type AttributeSourceEntityType = Extract<
  EntityType,
  | "company"
  | "feature-targeting-context-company"
  | "feature-targeting-context-user"
  | "feature-targeting-context-other"
>;

export function useAttributeNames(
  type?: AttributeSourceEntityType,
  filter?: string,
) {
  // Keep separate observers so placeholder names cannot cross context sources.
  const queries = {
    company: useCompanyAttributesData(type === "company", filter),
    "feature-targeting-context-company":
      useFeatureTargetingContextAttributeKeys(
        type === "feature-targeting-context-company" ? "company" : undefined,
        filter,
      ),
    "feature-targeting-context-user": useFeatureTargetingContextAttributeKeys(
      type === "feature-targeting-context-user" ? "user" : undefined,
      filter,
    ),
    "feature-targeting-context-other": useFeatureTargetingContextAttributeKeys(
      type === "feature-targeting-context-other" ? "other" : undefined,
      filter,
    ),
  };
  const result = type ? queries[type] : undefined;

  return {
    attributes: (result?.data ?? []).map((attribute) =>
      withObservedAttributeType(
        result?.isPlaceholderData || result?.isError
          ? { ...attribute, observedTypes: [] }
          : attribute,
      ),
    ),
    isLoading: result?.isLoading ?? false,
    isError: result?.isError ?? false,
    isPlaceholderData: result?.isPlaceholderData ?? false,
  };
}
